export default {
  base: '/',
  landingPage: '/',
  login: '/login',
  authenticate: '/authenticate',
  unauthorizedGenesis: '/unauthorized-application',
  forbidden: '/forbidden',
  forbiddenAccess: '/forbidden-access',
  notAuthorized: '/not-authorized',
  blockedAddress: '/blocked-address',
  error: '/error',
  authError: '/auth-error',
  logout: '/logout',
  unauthorized: '/unauthorized-application',

  // Genesis routes (keep existing structure)
  home: '/home',
  dashboard: '/dashboard',
  activity: '/mainatenance/activities',
  maintenance: '/maintenance/:tabName',
  locations: '/maintenance/:tabName/:subTabName',
  activityEntryExit: '/mainatenance/:tabName/:subTabName',
  audit: '/audits/:tabName',

  gemini: '/gemini/:tabName',

  userAndRoles: '/user-role/:tabName',
  addRoleAndPermissions: '/user-role/role-permissions/add',
  modifyRoleAndPermissions: '/user-role/role-permissions/modify/:roleId',

  nominations: '/nominations/:tabName',
  nominationsHistory: '/nominations/:tabName/:subTabName',

  senseCheck: '/sense-check/:tabName',

  trade: '/trade/:tabName',

  cva: '/cva/:tabName',

  summaryReports: '/summary-reports/:tabName',

  fieldNoms: '/field-noms/:tabName',
  terminalMapping: '/field-noms/field-nominations/terminal-mapping',
  daNoms: '/field-noms/field-nominations/da-noms',
  coastKeyMapper: '/trade/beach-swaps/coast-key-mapper',
  swingContractMapping: '/trade/swing-contracts/mapping',

  // EOS routes (6 main tabs)
  eosDashboard: '/eos/dashboard',
  eosScenarioAnalysis: '/eos/scenario-analysis',
  eosForecast: '/eos/forecast',
  eosCapacity: '/eos/capacity',
  eosAudit: '/eos/audit',
  eosMappingConfig: '/eos/mapping-config',
  eosRolesAndManagement: '/eos/roles-and-management',
  eosISG: '/eos/isg',

  // New Genesis routes
  newGenesisDashboard: '/new-genesis/dashboard',
  newGenesisDashboardHealthCheck: '/new-genesis/dashboard',
  newGenesisMessaging: '/new-genesis/messaging/:subTabName',
  newGenesisMessagingInbox: '/new-genesis/messaging/inbox',
  newGenesisMessagingExternalInbox: '/new-genesis/messaging/external-inbox',
  newGenesisMessagingFlatDeals: '/new-genesis/messaging/flat-deals',
  newGenesisPositions: '/new-genesis/positions/:subTabName',
  newGenesisPositionsMarketPosition: '/new-genesis/positions/market-position',
  newGenesisPositionsBalances: '/new-genesis/positions/balances',
  newGenesisPositionsContractView: '/new-genesis/positions/contract-view',
  newGenesisSystemAdmin: '/new-genesis/system-admin/:tabName',
};
